import { useState } from 'react';

import { DossierResponseDto } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { backAlertMessage } from 'hooks/utils/backAlertMessage';

export function useSubmitIdentifiabiliteProprietaire(
  dossierId: string,
  setDossier: (dossier: DossierResponseDto) => void,
  closeModal: () => void,
): [() => void, boolean] {
  const [inProgress, setInProgress] = useState<boolean>(false);
  const controller = useApi().ForceOrdreControllerApi;
  return [
    () => {
      setInProgress(true);
      return controller
        .confirmNonIdentifiabiliteProprietaireUsingPOST(dossierId)
        .then(setDossier)
        .then(closeModal)
        .catch((error: Response) => {
          void backAlertMessage(error);
        })
        .finally(() => {
          setInProgress(false);
        });
    },
    inProgress,
  ];
}
